;(function ($, window, document) {
  function onDOMContentLoaded() {
    var parent = $('#insurance-calculator')
    var kilpailutus = $('#kilpailutus')
    if (parent.length === 0) {
      // our work here is done
      return
    }
    var firstList = $('#insuranceTypes select')
    var secondList = $('#insuranceItem select')

    // call once immediately when ready
    doResize()

    // handle screen resizes: adjust continue-button size
    $(window).on('resize', function () {
      doResize()
    })

    function doResize() {
      var continueBtn = $('#continueBtn')
      if (
        parent[0].clientWidth <= 959 &&
        continueBtn.is('.btn-lg') &&
        continueBtn.not('.btn-md')
      ) {
        continueBtn.addClass('btn-md')
        continueBtn.removeClass('btn-lg')
      } else if (
        parent[0].clientWidth > 959 &&
        continueBtn.not('.btn-lg') &&
        continueBtn.is('.btn-md')
      ) {
        continueBtn.addClass('btn-lg')
        continueBtn.removeClass('btn-md')
      }
      if (kilpailutus) {
        toggleTexts()
      }
    }

    function selectClassToggler() {
      if (
        typeof firstList !== 'undefined' &&
        typeof secondList !== 'undefined'
      ) {
        if (
          firstList[0].value.length !== 0 &&
          !parent.hasClass(firstList[0].value)
        ) {
          var toggleClass = firstList[0].value
          parent.removeClass(parent[0].className)
          parent.addClass(toggleClass)
        }
      }
      if (firstList[0].value.length === 0) {
        parent.removeClass(parent[0].className)
      }
      // remove display: none from select
      parent[0].querySelector(`select#${toggleClass}`).style = ''
    }

    // check if user returns to page and something is selected
    if (firstList.prop('selectedIndex') !== 0) {
      parent.addClass(firstList[0].value)
      addLink()
    }

    firstList.on('change', function () {
      clearSecondList()
    })

    function clearSecondList() {
      selectClassToggler()
      secondList.prop('selectedIndex', function () {
        return 0
      })
      addLink()
    }

    parent.on('change', function () {
      toggleTexts()
    })

    function toggleTexts() {
      var selectedType = firstList.prop('selectedIndex') - 1
      var insuranceType = null
      if (secondList[selectedType]) {
        insuranceType = secondList[selectedType].id
      }
      var selectedItem
      if (typeof $('#insuranceItem select#' + insuranceType) !== 'undefined') {
        selectedItem = $('#insuranceItem select#' + insuranceType).prop(
          'selectedIndex'
        )
      }

      // text display toggles
      if (
        firstList[0].value.length !== 0 &&
        secondList[selectedType][selectedItem].value.length === 0
      ) {
        $('#firstText').css('display', 'none')
        $('#secondText').css('display', 'block')
        $('#thirdText').css('display', 'none')
      } else if (
        firstList[0].value.length !== 0 &&
        secondList[selectedType][selectedItem].value.length !== 0
      ) {
        $('#firstText').css('display', 'none')
        $('#secondText').css('display', 'none')
        // WEB-9823: the hero is too small for all of the text
        // in /vakuutukset/vakuutusten-kilpailutus ...
        // Don"t display the third text between 600px<-->350px since
        // the #continueBtn would otherwise overflow
        if (
          kilpailutus &&
          (parent[0].clientWidth > 599 || parent[0].clientWidth < 350)
        ) {
          $('#thirdText').css('display', 'block')
        } else {
          $('#thirdText').css('display', 'none')
        }
        addLink()
      }
    }
    function addLink() {
      // find selected insuranceItem and add correct url to link button
      // the "secondList[selectedType][selectedItem].value" is the
      // selected insuranceItem"s value
      var selectedType = firstList.prop('selectedIndex') - 1
      var insuranceType = secondList[selectedType].id
      var selectedItem
      if (typeof $('#insuranceItem select#' + insuranceType) !== 'undefined') {
        selectedItem = $('#insuranceItem select#' + insuranceType).prop(
          'selectedIndex'
        )
      }
      if (
        typeof selectedItem !== 'undefined' &&
        secondList[selectedType][selectedItem].value.length !== 0
      ) {
        $('#continueBtn').css('display', 'block')
        secondList.children().each(function () {
          if (
            typeof $(this).attr('data-url') !== 'undefined' &&
            $(this).attr('value') ==
              secondList[selectedType][selectedItem].value
          ) {
            var url = $(this).attr('data-url')
            $('#continueBtn').attr('href', url)
            return false
          }
        })
      } else {
        $('#continueBtn').css('display', 'none')
      }
    }
  }
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }
})(jQuery, window, document)
